<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :showFooter="showFooter">
    <div class="row">
      <div class="col-3 mb-3 mt-1">
        <div class="generalTitleItemModal">Usuario BO</div>
        <div>{{ renewData.backOfficeUser || "-" }}</div>
      </div>
      <div class="col-3 mb-3 mt-1">
        <div class="generalTitleItemModal">Dni</div>
        <div>{{ renewData.legalIdentifier || "-" }}</div>
      </div>
      <div class="col-3 mb-3 mt-1">
        <div class="generalTitleItemModal">Nº Contrato</div>
        <div>{{ renewData.newContractId || "-" }}</div>
      </div>
      <div class="col-3 mb-3 mt-1">
        <div class="generalTitleItemModal">Nº Contrato antiguo</div>
        <div>{{ renewData.parentContractId || "-" }}</div>
      </div>
      <div class="col-3 mb-3 mt-1">
        <div class="generalTitleItemModal">Nº Tienda</div>
        <div>{{ renewData.store || "-" }}</div>
      </div>
      <div class="col-3 mb-3 mt-1">
        <div class="generalTitleItemModal">Dispositivo renovación</div>
        <div>{{ renewData.deviceModel || "-" }}</div>
      </div>
      <div class="col-3 mb-3 mt-1">
        <div class="generalTitleItemModal">Dispositivo a entregar</div>
        <div>{{ renewData.previousDeviceModel || "-" }}</div>
      </div>
      <div class="col-3 mb-3 mt-1">
        <div class="generalTitleItemModal">Fecha renovación</div>
        <div>{{ renewData.dateOfRequest || "-" }}</div>
      </div>
      <div class="col-3 mb-3 mt-1">
        <div class="generalTitleItemModal">Cuota de cancelación</div>
        <div>{{ renewData.cancellationFee || "-" }}</div>
      </div>
      <div class="col-3 mb-3 mt-1">
        <div class="generalTitleItemModal">Cuota de renovación</div>
        <div>{{ renewData.renewalFee || "-" }}</div>
      </div>
      <div class="col-3 mb-3 mt-1">
        <div class="generalTitleItemModal">Url Solicitud</div>
        <div>
          <div v-if="!renewData.trackingUrl || renewData.trackingUrl === ''" class="text-muted">
            URL no disponible
          </div>
          <div v-else>
            <div class="d-flex gap-1 mb-2" style="gap: 5px !important;">
              <button
                class="btn btn-sm btn-outline-primary"
                @click="openUrl(renewData.trackingUrl)"
                title="Abrir enlace"
              >
                <v-icon name="bi-box-arrow-up-right" scale="0.8" class="me-1"/>
                Abrir enlace
              </button>
              <button
                class="btn btn-sm btn-outline-secondary"
                @click="copyUrl(renewData.trackingUrl)"
                title="Copiar enlace"
              >
                <v-icon name="bi-clipboard" scale="0.8" class="me-1"/>
                Copiar enlace
              </button>
            </div>
            <div v-if="urlCopiedNotification" class="alert alert-success py-1 px-2 mb-0" style="font-size: 0.8rem;">
              {{ urlCopiedNotification }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
  <ModalError :id="'modalError'" :modalTitle="'SE HA PRODUCIDO UN ERROR'" :class="'modal'" :showFooter="false"
    :message="errorMessage" :code="errorCode" :status="statusSelected"/>
</template>

<script>
import Modal from '../../../Widgets/Shared/Modal.vue';
import ModalError from '../../Shared/ModalError.vue';
import { Modal as ModalBootstrap } from "bootstrap";
import axios from 'axios';

export default {
  name: 'RenewsDetails',
  props: [
    'id',
    'modalTitle',
    'class',
    'showFooter',
    'numContract',
    'statusSelected'
  ],
  components: {
    Modal,
    ModalError
  },
  data() {
    return {
      renewData: '',
      classes: this.class,
      errorMessage: "",
      errorCode: "",
      urlCopiedNotification: ''
    }
  },
  methods: {
    getDetails() {
      axios.get(`/contract-renewal/${this.numContract}`)
        .then((response) => {
          this.renewData = response.data;
        })
        .catch((error) => {
          this.errorMessage = error.response.data.message
          this.errorCode = error.response.data.code
          var myModal = new ModalBootstrap(document.getElementById('modalError'));
          myModal.show();
        });
    },
    openUrl(url) {
      if (url) {
        window.open(url, '_blank');
      }
    },
    async copyUrl(url) {
      if (!url) return;
      try {
        await navigator.clipboard.writeText(url);
        this.urlCopiedNotification = 'Enlace copiado al portapapeles';
        setTimeout(() => { this.urlCopiedNotification = ''; }, 3000);
      } catch (err) {
        console.error('Error al copiar URL:', err);
        const textArea = document.createElement('textarea');
        textArea.value = url;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.urlCopiedNotification = 'Enlace copiado al portapapeles';
        setTimeout(() => { this.urlCopiedNotification = ''; }, 3000);
      }
    }
  },
  updated() {
    this.getDetails();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
